import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const EyeExamHistoryPage = lazy(() => import("./EyeExamHistoryPage"));

const EyeExamHistoryPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <EyeExamHistoryPage />
    </Suspense>
  );
};

export default EyeExamHistoryPageLazy;
